import { analyticsService } from 'utils/services/analytics'

export const sendPublishErrorToAnalytics = (error: string) => {
  analyticsService.sendEvent('BUILDER.PUBLISH_ERROR', { error })
}
